import React, { FC } from 'react'
import classNames from 'classnames'

import { Typography, IconMoon } from '@/atoms'
import {
  CountryClientsCardTitleProps,
  CountryClientsCardProps,
  CountryClientsCardItemsProps,
  CountryClientsCardItemProps,
} from '@/types'
import { getStyledElementProps } from '@/utils'
import styles from './country-clients-card.module.scss'

export const CountryClientsCardTitle: FC<CountryClientsCardTitleProps> = ({
  image,
  iconFunction,
  children,
  alt = '',
  width = '40',
  height = '40',
  loading = 'lazy',
  ...props
}) => {
  return (
    <div className={styles['title']}>
      {image && (
        <img
          className={styles['image']}
          src={image}
          alt={alt}
          width={width}
          height={height}
          loading={loading}
        />
      )}
      <Typography
        variant={'headline-3'}
        tag={'span'}
        typographyColor={'gray-6'}
        style={{ marginTop: '2px' }}
        {...props}
      >
        {children}
      </Typography>
      <IconMoon
        name={'icon-cross'}
        size={'sm'}
        className={styles['caret-icon']}
        style={{
          marginTop: '10px',
          right: '16px',
          color: '#000000',
          cursor: 'pointer',
        }}
        onClick={() => iconFunction()}
      />
    </div>
  )
}

export const CountryClientsCardItems: FC<CountryClientsCardItemsProps> = ({
  items,
  ...props
}) => {
  return (
    <div className={styles['items']}>
      {items?.map((item: CountryClientsCardItemProps) => (
        <div
          className={styles['item']}
          key={item?.key}
          style={{ display: 'flex' }}
        >
          <Typography
            variant={'body-1'}
            tag={'span'}
            typographyColor={'gray-6'}
            {...props}
          >
            {item?.name}
          </Typography>
          <br />
        </div>
      ))}
    </div>
  )
}

export const CountryClientsCard: FC<CountryClientsCardProps> = ({
  children,
  variant = 'default',

  ...props
}) => {
  const styledProps = getStyledElementProps(
    props,
    classNames(styles['root'], styles[variant])
  )
  return <div {...styledProps}> {children} </div>
}
